import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { Stack } from '@mui/material';
import { Duration, Timer } from './styles';
import { useTimeLogs } from '@/hooks/useTimeLogs';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import * as state from '@/state';
import {
  PausedBy,
  useWorkFlowTimeUpdatedSubscription,
  Zone,
  ZoneState,
} from '@/__generated__/graphql';
import { useWorkFlowTimeAndStateUpdater } from '@/hooks/useUpdateWorkFlowTimeAndState';
import { convertMilliSecondToFormattedTime } from '@/utils';
import { useTimeTrackingUpdates } from '@/hooks/useTimeTrackingUpdates';
import { useGetStructureId } from '@/hooks/useGetStructureId';

export const TimeTracking = () => {
  const [selectedZone, setSelectedZone] = useAtom(state.selectedZone);
  const { updatedWorkflowTimeAndState } = useWorkFlowTimeAndStateUpdater();
  const timeInMsForLogging = 60000; // 60 seconds or 1 minute
  const structureId = useGetStructureId();

  useTimeTrackingUpdates(timeInMsForLogging);
  useTimeLogs();
  useEffect(() => {
    const handleUnload = () => {
      if (selectedZone?.workflowStatus?.state === ZoneState.Start) {
        updatedWorkflowTimeAndState({
          typeOfTimeLog: 'totalTime',
        });
      } else if (
        selectedZone?.workflowStatus?.state === ZoneState.Pause &&
        selectedZone.workflowStatus.pausedBy === PausedBy.System
      ) {
        updatedWorkflowTimeAndState({
          typeOfTimeLog: 'idleTime',
        });
      }
    };

    window.addEventListener('unload', handleUnload);
    return () => {
      window.removeEventListener('unload', handleUnload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { data: updatedWorkFlow } = useWorkFlowTimeUpdatedSubscription({
    variables: {
      structureId,
      zoneId: selectedZone?.id,
    },
    skip: !structureId,
  });

  const userId = selectedZone?.workflowStatus?.assignedToUser?.id;
  const statusId = selectedZone?.workflowStatus?.workflowStageId;
  useEffect(() => {
    if (updatedWorkFlow?.workFlowTimeUpdated) {
      setSelectedZone((prev) => {
        return {
          ...prev,
          workflowStatus: updatedWorkFlow.workFlowTimeUpdated.workflowStatus,
        } as Zone;
      });
    }
  }, [setSelectedZone, updatedWorkFlow]);
  return (
    <Stack direction="row" gap="1.6rem">
      <Timer>
        <AbyssIcon iconName="timer" />
        <Duration>
          Active time:
          {userId && statusId
            ? convertMilliSecondToFormattedTime(
                selectedZone?.workflowStatus?.totalTime?.[userId]?.[statusId]
              )
            : 'N/A'}
        </Duration>
      </Timer>
      <Timer>
        <AbyssIcon iconName="timer" />
        <Duration>
          Idle time:
          {userId && statusId
            ? convertMilliSecondToFormattedTime(
                selectedZone?.workflowStatus?.idleTime?.[userId]?.[statusId]
              )
            : 'N/A'}
        </Duration>
      </Timer>
    </Stack>
  );
};
